module.exports = __webpack_public_path__ + "static/media/29FUNOV3.2336f172.jpg";